import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { ICPReport } from "../../../models/CPReport";
import { format } from "date-fns";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface Iprops {
    vendor_Company_ID?: number,
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const POReport = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ICPReport>, loading: boolean });

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Report_Sales/companypo", "GET", null, `companyID=${props.vendor_Company_ID}`, props.toast);
        if (response) {
            const data: Array<ICPReport> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: [], loading: false });
    }

    useEffect(() => {
        if (props.vendor_Company_ID) loadTableData();
    }, [props.vendor_Company_ID]);

    const onHide = () => {
        props.hideDialog();
    }

    const addDate = (rowData: ICPReport) => {
        let date;
        if (rowData.addDate) date = format(new Date(rowData.addDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const tDate = (rowData: ICPReport) => {
        let date;
        if (rowData.tDate) date = format(new Date(rowData.tDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DataFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Contact Person Wise Performance Report" className="p-fluid" draggable={false} onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="contact_Person_Name" header="Contact Person Name" />
                <Column field="user_name" header="Sales Manager" />
                {/* <Column field="addDate" header="Add Date" body={addDate} />
                <Column field="tDate" header="Transfer Date" body={tDate} /> */}
                <Column field="addDate" header="Add Date" body={(rowData: any) => safeFormatDate(rowData.addDate, 'dd/MM/yyyy', DataFormat)} />
                <Column field="tDate" header="Transfer Date" body={(rowData: any) => safeFormatDate(rowData.tDate, 'dd/MM/yyyy', DataFormat)} />
                <Column field="noOfReq" header="#Req" />
                <Column field="noOfSub" header="#Sub" />
                <Column field="noOfEndClient" header="#Client" />
                <Column field="noOfECI" header="#ECI" />
                <Column field="noOfPO" header="#PO" />
            </DataTable>
        </Dialog>
    );
}